<template>
  <div id="app" class="relative bg">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
    <v-msg ref="msg"></v-msg>
    <v-loading :show-tag="showLoading"></v-loading>
    <v-popup ref="popup"></v-popup>
    <v-refresh-loading></v-refresh-loading>
    <photo-sswiper ref="photoSwiper"></photo-sswiper>
    <pic-fullscrenn-scan ref="zoom"></pic-fullscrenn-scan>
    <v-share ref="share"></v-share>
    <online-kefu></online-kefu>
  </div>
</template>
<script>
  import VMsg from './components/common/v-msg'
  import VLoading from './components/common/v-loading'
  import VPopup from './components/common/v-popup'
  import VRefreshLoading from './components/common/v-refresh-loading'
  import PhotoSswiper from './components/common/photo-sswiper'
  import VShare from './components/common/v-share'
  import OnlineKefu from "./components/home/online-kefu"
  import PicFullscrennScan from "./components/common/pic-fullscrenn-scan";
  import {getParamsFromUrl} from "./lib/utils";
  import {cacheMixin} from "./mixins/cache";
  import {userCache} from "./lib/cache";
  import {SelectedHosCache} from "./lib/cache";
  import {OnlineHosCache} from "./lib/cache";


  export default {
    name: 'App',
    data () {
      return {
        loadingQueue: [],
        showLoading: false
      }
    },
    components: {VShare, PhotoSswiper, VRefreshLoading, VPopup, VLoading, VMsg, PicFullscrennScan, OnlineKefu},
    mixins: [cacheMixin],
    async created () {
      await this.setOpenid()

      bus.$on('share-mask', (data) => {
        data === true && this.$refs.share.show()
      })
      bus.$on("show-barcode", img => {
        this.$refs.zoom.show(img.src);
      });

      bus.$on('photo-swiper-show', (data) => {
        this.$refs.photoSwiper.show(data)
        Log('photo-swiper-show', data)
      })

      bus.$on('msg', (msg) => {
        this.$refs.msg.show(msg)
      })
      bus.$on('loading', (data) => {
        if (data === false) {
          let index = this.loadingQueue.findIndex(r => r.status === true)

          let item = this.loadingQueue[index] || {}
          item.status = false
          this.loadingQueue.splice(index, 1, item)
          if (this.loadingQueue.every(r => r.status === false)) {
            this.showLoading = false
            this.loadingQueue = []
          }
        } else {
          this.showLoading = true
          this.loadingQueue.push({
            t: new Date().toLocaleString(),
            status: true
          })
        }
      })
      bus.$on('popup', (type, data, level) => {
        if (type === true) {
          this.$refs.popup.show(level, data)
        } else {
          this.$refs.popup.hide()
        }
      })
    },
    methods: {
      async setOpenid () {
        let urlParams = getParamsFromUrl(location.href)
        let {query = {}} = urlParams
        if (query.token) {
          let {code, obj} = await this.$http('smarthos.user.pat.get', {})
          if (code == 0) {
            userCache.set(obj)
            this.user = obj
          }
        }
      }
    },
    watch: {
      showLoading (newV) {
        bus.$emit('showLoading', newV)
      }
    }
  }
</script>

<style lang="scss">
  @import "./style/base";
  @import "./style/program";
  @import "./style/mixin";

  #app, .page {
    height: calc(100vh);
  }

  .line2 {
    @include lines(2);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue